var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.778,
    viewBox: "0 1 20 17.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 2.615h-5.44a.857.857 0 0 1-.372-.085L7.39 1.255A2.579 2.579 0 0 0 6.273 1H4.167C1.869.999 0 2.81 0 5.04v9.697c0 2.228 1.87 4.04 4.167 4.04H5a.82.82 0 0 0 .833-.808.82.82 0 0 0-.833-.808h-.833c-1.379 0-2.5-1.088-2.5-2.424V7.464h16.666v7.273c0 1.336-1.121 2.424-2.5 2.424H15a.82.82 0 0 0-.833.808.82.82 0 0 0 .833.808h.833c2.298 0 4.167-1.812 4.167-4.04V6.656c0-2.228-1.87-4.041-4.167-4.041ZM1.667 5.039c0-1.336 1.121-2.424 2.5-2.424h2.106c.129 0 .259.03.373.085l2.63 1.275c.346.167.732.255 1.117.255h5.44c1.085 0 2.002.678 2.347 1.617H1.667v-.808Zm11.422 10.59a.79.79 0 0 1 0 1.143l-1.344 1.304a2.499 2.499 0 0 1-1.745.699 2.497 2.497 0 0 1-1.744-.7L6.91 16.773a.79.79 0 0 1 0-1.142.85.85 0 0 1 1.178 0l1.078 1.045v-5.979A.82.82 0 0 1 10 9.888a.82.82 0 0 1 .833.808v5.979l1.078-1.045a.85.85 0 0 1 1.178 0Z",
    fill: "#fd6036",
    fillRule: "evenodd",
    "data-name": "folder-download"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDownload);
export default __webpack_public_path__ + "static/media/folder-download.fca0ca0715d792f7bc52ebe301c4f1df.svg";
export { ForwardRef as ReactComponent };